var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 80,
    viewBox: "0 0 123 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.766 67.1865H6.79596C3.60695 67.1865 1.48095 64.509 2.06077 61.1869L11.3862 5.99969C11.966 2.67755 15.0101 0 18.1991 0H118.17C121.359 0 123.485 2.67755 122.905 5.99969L113.579 61.1869C112.999 64.509 109.955 67.1865 106.766 67.1865Z",
    fill: "#BDCCD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.432 79.2406C22.3077 79.2406 20.6281 77.5116 20.6281 75.4367V67.0384H28.2853V75.4367C28.2853 77.5116 26.5563 79.2406 24.432 79.2406Z",
    fill: "#BDCCD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7171 79.2406C89.5929 79.2406 87.9132 77.5116 87.9132 75.4367V67.0384H95.5705V75.4367C95.5211 77.5116 93.792 79.2406 91.7171 79.2406Z",
    fill: "#BDCCD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.031 22.8731L37.2765 44.1653H3.3374L6.89434 22.8731H41.031Z",
    fill: "#EA5449"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4041 22.8731L76.6495 44.1653H39.3017L43.0562 22.8731H80.4041Z",
    fill: "#EA5449"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.812 44.1653H78.7244L82.479 22.8731H116.369L116.714 20.7982H82.8248L86.4805 0H84.4056L80.7499 20.7982H43.4021L47.0578 0H44.9829L41.3766 20.7982H7.23989L6.89408 22.8731H40.9814L37.2268 44.1653H3.33714L2.99133 46.2402H36.881L33.2253 67.0384H35.3002L38.9559 46.2402H76.3037L72.648 67.0384H74.7228L78.3786 46.2402H112.515L112.812 44.1653ZM39.3017 44.1653L43.0562 22.8731H80.4041L76.6495 44.1653H39.3017Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.996 61.0114C109.452 64.3213 106.439 66.989 103.327 66.989H74.6735L78.3293 46.1908H112.466L109.996 61.0114Z",
    fill: "#EA5449"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.812 44.1653H78.7245L82.479 22.8731H116.369L112.812 44.1653Z",
    fill: "#EA5449"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.714 20.7982H82.8247L86.4804 0H114.491C117.604 0 119.728 2.6677 119.184 5.97763L116.714 20.7982Z",
    fill: "#EA5449"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4552 0L80.7501 20.7982H43.4023L47.1074 0H84.4552Z",
    fill: "#EA5449"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0324 0L41.3767 20.7982H7.23999L9.71008 5.97763C10.2535 2.6677 13.267 0 16.3793 0H45.0324Z",
    fill: "#EA5449"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3036 46.1908L72.6479 66.989H35.3L38.9558 46.1908H76.3036Z",
    fill: "#EA5449"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8811 46.1908L33.2253 66.989H5.21447C2.10215 66.989 -0.0221313 64.3213 0.570691 61.0114L3.04078 46.1908H36.8811Z",
    fill: "#EA5449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.ca0652aec5c39d33ffdf7b66ea06a6a8.svg";
export { ForwardRef as ReactComponent };